module.exports = __webpack_public_path__ + "img/logos.87a4ceef.png";